import React from 'react';

class CalculatorForm extends React.Component {
  
  render() {
    const { isDreamSpace } = this.props;
    const className = isDreamSpace ? 'dreamspace' : '';
    return (
     <div className="calculator-form">
       <div className={`calculator-form__fields ${className}`}>
        {this.props.children}
       </div>
       <button className={`calculator-form__submit ${className} btn btn-block btn-dark-green btn-xl`} onClick={this.props.handleSubmit}>Calculate</button>
     </div>
   )
 }
}

export default CalculatorForm;
